import { Injectable } from '@angular/core';

import { State, Action, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs/operators';

import { CourtEventService, AddCourtEventNoteModel } from '@bayclubs/court-booking-employee-api';
import { BcStateForm } from '@bayclubs/state';

import { CoreFacade } from '@core/core.module';

import { COURT_EVENT_NOTE_SAVE_FEATURE_KEY, CourtEventNoteSaveStateModel } from './court-event-note-save.state.model';
import * as actions from './court-event-note-save.actions';

const initialState = {
    form: BcStateForm.Empty()
} as CourtEventNoteSaveStateModel;

@Injectable({ providedIn: 'root' })
@State({ name: COURT_EVENT_NOTE_SAVE_FEATURE_KEY, defaults: initialState })
export class CourtEventNoteSaveState {
    constructor(
        private courtEventApiService: CourtEventService,
        private coreFacade: CoreFacade
    ) { }

    @Action(actions.SaveCourtEventNoteAction)
    saveCourtEventNote(ctx: StateContext<CourtEventNoteSaveStateModel>, action: actions.SaveCourtEventNoteAction) {
        const state = ctx.getState();
        const club = this.coreFacade.selectedClub();
   
        const request = {
            note: state.form.model.note
        } as AddCourtEventNoteModel;

        ctx.patchState({ form: BcStateForm.Loading(state.form, true) });

        return this.courtEventApiService
            .api10ClubIdCourteventsCourtEventIdNotesPost({ clubId: club.id, courtEventId: action.courtEventId, addCourtEventNoteModel: request  })
            .pipe(
                tap(value => {
                    ctx.patchState({ form: BcStateForm.Loading(state.form, false) });
                    ctx.dispatch(new actions.SaveCourtEventNoteSuccessAction());
                }),
                catchError(err => {
                    ctx.patchState({ form: BcStateForm.Loading(state.form, false) });
                    throw err;
                })
            );
    }

    @Action(actions.ResetCourtEventNoteFormAction)
    resetCourtEventNoteForm(ctx: StateContext<CourtEventNoteSaveStateModel>) {
        ctx.patchState({ form: BcStateForm.Empty() });
    }
}
